import React, { useState } from 'react';
import './productreview.css';

export default function ProductReview() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [visibleCount, setVisibleCount] = useState(3);

  const reviews = [
    {
      category: "Mobiles",
      user: "Rahul M.",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
      rating: 5,
      review: "Absolutely loving this phone! Great battery life and the display is super crisp. Worth every rupee.",
      image: "https://www.pngarts.com/files/3/Smartphone-Mobile-PNG-Image-Background.png"
    },
    {
      category: "Tools",
      user: "Ankit P.",
      avatar: "https://randomuser.me/api/portraits/men/45.jpg",
      rating: 4,
      review: "Good quality tools, perfect for home repairs. The screwdriver is very sturdy.",
      image: "https://www.pngall.com/wp-content/uploads/10/Tools-PNG-Photos.png"
    },
    {
      category: "Plumbing",
      user: "Priya R.",
      avatar: "https://randomuser.me/api/portraits/women/68.jpg",
      rating: 4,
      review: "Fixed my leaking tap in minutes. Simple and effective tools for any household plumbing issue.",
      image: "https://i.pinimg.com/originals/ae/65/fb/ae65fbf16b24ed45bb172e932dc79807.png"
    },
    {
      category: "Painting",
      user: "Devansh K.",
      avatar: "https://randomuser.me/api/portraits/men/50.jpg",
      rating: 5,
      review: "Easy to use and gave my walls a smooth finish. No dripping or patchy spots!",
      image: "https://png.pngtree.com/png-vector/20231116/ourmid/pngtree-isolated-white-background-of-an-aged-png-image_10552531.png"
    },
    {
      category: "Cleaning",
      user: "Sneha T.",
      avatar: "https://randomuser.me/api/portraits/women/65.jpg",
      rating: 5,
      review: "These cleaning supplies made my kitchen sparkle! Especially loved the eco-friendly packaging.",
      image: "https://static.vecteezy.com/system/resources/previews/041/642/641/original/ai-generated-cleaning-product-isolated-on-transparent-background-png.png"
    },
    {
      category: "Mens Clothes",
      user: "Rohit S.",
      avatar: "https://randomuser.me/api/portraits/men/80.jpg",
      rating: 4,
      review: "Fits well and the fabric is very breathable. Delivered on time.",
      image: "https://cdn-icons-png.flaticon.com/512/892/892458.png"
    },
    {
      category: "Women Clothes",
      user: "Meera N.",
      avatar: "https://randomuser.me/api/portraits/women/22.jpg",
      rating: 5,
      review: "Beautiful design and color. My new favorite outfit!",
      image: "https://cdn-icons-png.flaticon.com/512/892/892451.png"
    },
    {
      category: "Unisex",
      user: "Tanya B.",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
      rating: 4,
      review: "Stylish and comfortable. Great for daily wear.",
      image: "https://img.huffingtonpost.com/asset/6494679e2000001b00c8b6b6.png?ops=scalefit_960_noupscale"
    },
    {
      category: "Footwear",
      user: "Karan J.",
      avatar: "https://randomuser.me/api/portraits/men/90.jpg",
      rating: 5,
      review: "These shoes are super comfy and lightweight. Perfect for everyday use!",
      image: "https://pluspng.com/img-png/shoes-png--1200.png"
    },
    {
      category: "Cosmetics",
      user: "Anjali V.",
      avatar: "https://randomuser.me/api/portraits/women/56.jpg",
      rating: 5,
      review: "Very gentle on skin and has a lovely fragrance. Would totally buy again.",
      image: "https://cdn-icons-png.flaticon.com/512/2920/2920242.png"
    }
  ];

  const filteredReviews = reviews.filter(
    (r) => selectedCategory === 'All' || r.category === selectedCategory
  );

  const visibleReviews = filteredReviews.slice(0, visibleCount);

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 3);
  };

  return (
    <div className="container review-container">
      <div className="review-intro text-center mb-4">
        <h2>🛍️ What Our Customers Are Saying</h2>
        <p>Browse real feedback from our happy users. Filter by product category!</p>
      </div>

      <div className="text-center mb-4">
        <select
          value={selectedCategory}
          onChange={(e) => {
            setSelectedCategory(e.target.value);
            setVisibleCount(3); // Reset on filter change
          }}
          className="category-filter"
        >
          <option value="All">All</option>
          {[...new Set(reviews.map((r) => r.category))].map((cat) => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
      </div>

      <div className="review-grid row">
        {visibleReviews.map((review, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <div className="review-card p-3 shadow-sm rounded h-100 text-center bg-white">
              <img src={review.avatar} alt={review.user} className="avatar mb-2 rounded-circle" />
              <h5>{review.user}</h5>
              <p className="text-warning">{'⭐'.repeat(review.rating)}</p>
              <p className="small text-muted">{review.review}</p>
              <img src={review.image} alt={review.category} className="img-fluid rounded mt-2" style={{ maxHeight: '120px' }} />
            </div>
          </div>
        ))}
      </div>

      {visibleCount < filteredReviews.length && (
        <div className="text-center mt-3">
          <button className="btn btn-primary" onClick={handleLoadMore}>Load More</button>
        </div>
      )}
    </div>
  );
}
